import loadable from "@loadable/component";
import { createBrowserRouter } from "react-router-dom";

const RetrieveAccount = loadable(() => import("../pages/RetrieveAccount"));
const SignAsUser = loadable(() => import("../pages/SignAsUser"));
const SignIn = loadable(() => import("../pages/SignIn"));
const SignoutAsUser = loadable(() => import("../pages/SignoutAsUser"));
const RecoverPassword = loadable(() => import("../pages/RecoverPassword"));
const ResetPassword = loadable(() => import("../pages/ResetPassword"));
const Error = loadable(() => import("../pages/Error"));

export const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <Error />,
    element: <SignIn />,
  },
  {
    path: "/sign-as-user/:token",
    errorElement: <Error />,
    element: <SignAsUser />,
  },
  {
    path: "/recover",
    errorElement: <Error />,
    element: <RecoverPassword />,
  },
  {
    path: "/retrieve-account",
    errorElement: <Error />,
    element: <RetrieveAccount />,
  },
  {
    path: "/reset/:token",
    errorElement: <Error />,
    element: <ResetPassword />,
  },
  {
    path: "/*",
    errorElement: <Error />,
    element: <SignoutAsUser />,
  },
]);
